import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { useFilters, useSortBy, useTable } from "react-table";

import { t } from "../../../services";

import { SearchInput, Table, WrapperContainer } from "../..";
import { FilterOptionsTableColumns } from "./FilterOptionsTableColumns";

const FilterOptionsTable = ({
  options,
  isSearchable = true,
  selectedOptions,
  onOptionsSelected,
  onSelectAll,
  searchPlaceholder,
  columnName,
  CellComponent
}) => {
  const [searchValue, setSearchValue] = useState("");

  const columns = useMemo(() => FilterOptionsTableColumns(columnName, CellComponent), [columnName]);
  const rows = useMemo(
    () =>
      options.map((x) => {
        return {
          ...x,
          selected: selectedOptions?.includes(x.id)
        };
      }),
    [selectedOptions, options]
  );

  const tableInstance = useTable(
    {
      columns,
      data: rows
    },
    useFilters,
    useSortBy
  );

  const { setFilter } = tableInstance;

  useEffect(() => {
    setFilter("value", searchValue);
  }, [rows, searchValue]);

  return (
    <WrapperContainer width={560}>
      {isSearchable && (
        <WrapperContainer width="100%" mb={16}>
          <SearchInput
            id="option-modal-search"
            value={searchValue}
            setValue={setSearchValue}
            placeholder={t(searchPlaceholder)}
          />
        </WrapperContainer>
      )}

      <Table
        tableInstance={tableInstance}
        maxTableHeight="108px"
        componentHeight={64}
        searchedText={searchValue}
        modalTable
        callbackFn1={onOptionsSelected}
        callbackFn2={onSelectAll}
        onRowClick={(option) => onOptionsSelected(option.id)}
        maxVisibleRows={6}
        showTableBorder
      />
    </WrapperContainer>
  );
};

FilterOptionsTable.propTypes = {
  options: PropTypes.array.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  onOptionsSelected: PropTypes.func.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
  isSearchable: PropTypes.bool,
  onSelectAll: PropTypes.func.isRequired,
  columnName: PropTypes.string.isRequired,
  CellComponent: PropTypes.object
};

export default FilterOptionsTable;
